import type { StatsChartProps } from '@ui/components/StatsCharts/StatsChart';
import { useTranslations } from '@ui/i18n';
import { useMemo } from 'react';

import { useStatsFountainUsdLocked } from './useStatsFountainUsdLocked';
import { useStatsFountainVnoLocked } from './useStatsFountainVnoLocked';

export const useStatsFountainTvl = (
  startTimestamp: number,
  endTimestamp: number,
  options?: { enabled: boolean },
): StatsChartProps => {
  const t = useTranslations();
  const vnoResult = useStatsFountainVnoLocked(
    startTimestamp,
    endTimestamp,
    options,
  ).data;
  const usdResult = useStatsFountainUsdLocked(
    startTimestamp,
    endTimestamp,
    options,
  ).data;

  return useMemo(
    () => ({
      title: t('Fountain Total VNO Locked'),
      values: {
        [t('{num} Months', {
          num: 3,
        })]: vnoResult?.pid0FountainVnoLocked,
        [t('{num} Months', {
          num: 12,
        })]: vnoResult?.pid1FountainVnoLocked,
        [t('{num} Months', {
          num: 48,
        })]: vnoResult?.pid2FountainVnoLocked,
        [t('{num} Months', {
          num: 96,
        })]: vnoResult?.pid3FountainVnoLocked,
      },
      type: 'pie',
      units: ['VNO', 'USD'],
      alternativeValues: {
        [t('{num} Months', {
          num: 3,
        })]: usdResult?.pid0FountainUsdLocked,
        [t('{num} Months', {
          num: 12,
        })]: usdResult?.pid1FountainUsdLocked,
        [t('{num} Months', {
          num: 48,
        })]: usdResult?.pid2FountainUsdLocked,
        [t('{num} Months', {
          num: 96,
        })]: usdResult?.pid3FountainUsdLocked,
      },
    }),
    [vnoResult, usdResult, t],
  );
};
